import { Navigate, useParams } from "../../../../../router-utils"

export default function MailIntegrationOverviewPage() {
	const { integrationId } = useParams("/integrations/:integrationId/mail")

	return (
		<Navigate
			to="/integrations/:integrationId/mail/mailboxes"
			params={{ integrationId }}
			replace
		/>
	)
}
